import { type ReactNode } from 'react';
import DashBar from './partials/DashBar';
import DashHero from './partials/DashHero';
import DashMetrics from './partials/DashMetrics';
import DashPayments from './partials/DashPayments';
import DashPrice from './partials/DashPrice';
import DashTerm from './partials/DashTerm';
import type {
    AnalyticsDashDeadline,
    AnalyticsDashMetric,
    AnalyticsDashPayments,
    AnalyticsDashSegment,
} from './model';

export type {
    AnalyticsBarTone,
    AnalyticsDashDeadline,
    AnalyticsDashMetric,
    AnalyticsDashPayments,
    AnalyticsDashSegment,
} from './model';

interface ObjectAnalyticsDashProps {
    isUahMode: boolean;
    profitability: number;
    profitabilityRate?: number;
    profitabilityLabel: string;
    price: number;
    /** Збережена сума за курсом (objectPriceRate). */
    priceRateAmount?: number;
    actualCostLabel?: string;
    actualCostAmount?: number;
    actualCostDisabled?: boolean;
    segments: AnalyticsDashSegment[];
    /** Вартість окремим рядком над сіткою блоків */
    priceRow?: AnalyticsDashMetric | null;
    metrics: AnalyticsDashMetric[];
    payments?: AnalyticsDashPayments | null;
    payStatus?: ReactNode;
    deadline?: AnalyticsDashDeadline | null;
    /** Без дохідності, собівартості і маржі. Лишаються роздріб, оплати і дедлайн. */
    hideProfitability?: boolean;
}

const ObjectAnalyticsDash = ({
    isUahMode,
    profitability,
    profitabilityRate,
    profitabilityLabel,
    price,
    priceRateAmount,
    actualCostLabel,
    actualCostAmount,
    actualCostDisabled = false,
    segments,
    priceRow,
    metrics,
    payments,
    payStatus,
    deadline,
    hideProfitability = false,
}: ObjectAnalyticsDashProps) => (
    <div className="object-analytics-dash">
        {hideProfitability ? null : (
            <DashHero
                isUahMode={isUahMode}
                profitability={profitability}
                profitabilityRate={profitabilityRate}
                profitabilityLabel={profitabilityLabel}
                price={price}
            />
        )}
        {hideProfitability ? null : (
            <DashBar isUahMode={isUahMode} segments={segments} profitabilityLabel={profitabilityLabel} />
        )}
        <DashPrice
            isUahMode={isUahMode}
            price={price}
            priceRateAmount={priceRateAmount}
            priceRow={priceRow}
            actualCostLabel={hideProfitability ? undefined : actualCostLabel}
            actualCostAmount={hideProfitability ? undefined : actualCostAmount}
            actualCostDisabled={actualCostDisabled}
        />
        <DashMetrics isUahMode={isUahMode} metrics={metrics} />
        {payments ? <DashPayments isUahMode={isUahMode} payments={payments} /> : null}
        {payStatus ? <div className="object-analytics-dash__status">{payStatus}</div> : null}
        {deadline ? <DashTerm deadline={deadline} /> : null}
    </div>
);

export default ObjectAnalyticsDash;
